import { RecordMask } from '@skinsoft/record-mask';

/* tslint:disable:object-literal-sort-keys */

// tslint:disable-next-line:variable-name
export const auditRecord_recordMask: RecordMask = {
    "name": {
        "translatedString": {
            "fr": "Masque Reporter"
        },
        "translatedId": null
    },
    "categories": [
        {
            "label": {
                "translatedString": {
                    "fr": "Identification de la fiche de récolement",
                    "fr-ca": "Identification de la fiche de récolement",
                    "en": "Identification of the audit report",
                    "nl": "Identificatie van het auditrapport",
                    "es": "Identificación del informe de auditoría",
                    "it": "Identificazione del rapporto di audit",
                    "no": "Identifisering av revisjonrapporten",
                    "de": "Identifizierung des Prüfberichts"
                },
                "translatedId": null
            },
            "maskFields": [
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e27d",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementIdentificationSchema",
                        "name": "numberIdentifier",
                        "mandatorySystem": false,
                        "type": {
                            "type": "String",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementIdentificationSchema.numberIdentifier",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7907aba0001ac69fe",
                        "name": "text",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca6a7857aaa0001ac68db",
                        "name": "text-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 0,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e27f",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementIdentificationSchema",
                        "name": "recoleur",
                        "mandatorySystem": false,
                        "type": {
                            "type": "List",
                            "entityFieldType": {
                                "type": "Alias",
                                "subTypes": [],
                                "filter": "591ca6a8857aca1231abcd4e",
                                "isRestrictive": false,
                                "esPath": "aliasSchema.tags.ref",
                                "trueType": "Alias>",
                                "useTrueType": false,
                                "referenceField": true
                            },
                            "listClass": null,
                            "referenceField": true
                        },
                        "isReadOnly": true,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementIdentificationSchema.recoleur",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "591ca0a7907aba0001ac69fe",
                        "name": "reference-title",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca2a7857aaa0001ac29de",
                        "name": "reference-input-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 1,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e280",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementIdentificationSchema",
                        "name": "supervisor",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Alias",
                            "subTypes": [],
                            "filter": "591ca6a8857aca1231abcd4e",
                            "isRestrictive": false,
                            "esPath": "aliasSchema.tags.ref",
                            "trueType": "Alias",
                            "useTrueType": false,
                            "referenceField": true
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementIdentificationSchema.supervisor",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "591ca0a7907aba0001ac69fe",
                        "name": "reference-title",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca2a7857aaa0001ac29de",
                        "name": "reference-input-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 2,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e281",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementIdentificationSchema",
                        "name": "context",
                        "mandatorySystem": false,
                        "type": {
                            "type": "TranslatedString",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementIdentificationSchema.context",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7907aba0001ac69fe",
                        "name": "text",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca6a7857aaa0001ac68db",
                        "name": "text-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 3,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                }
            ]
        },
        {
            "label": {
                "translatedString": {
                    "fr": "Pointage",
                    "fr-ca": "Pointage",
                    "en": "Audit",
                    "nl": "Controle",
                    "es": "Puntuación",
                    "it": "Punteggio",
                    "no": "Avkryssing",
                    "de": "Standpunkt",

                },
                "translatedId": null
            },
            "maskFields": [
                {
                    "entityField": {
                        "entityFieldId": "5e7b837114256b1944f06a7d",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "stolen",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.stolen",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 0,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2a4",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "localized",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.localized",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 1,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2a5",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "presenceInventoryNumber",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.presenceInventoryNumber",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 2,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2a6",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "identifiable",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.identifiable",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 3,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2a7",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "markedOnObject",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.markedOnObject",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 4,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2a8",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "markedOnLabel",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.markedOnLabel",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 5,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2a9",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "markedOnSupport",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.markedOnSupport",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 6,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2aa",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "supportCommentary",
                        "mandatorySystem": false,
                        "type": {
                            "type": "TranslatedString",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.supportCommentary",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7907aba0001ac69fe",
                        "name": "text",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca6a7857aaa0001ac68db",
                        "name": "text-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 7,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2ab",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "otherNumber",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.otherNumber",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 8,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2ac",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "otherNumberCommentary",
                        "mandatorySystem": false,
                        "type": {
                            "type": "TranslatedString",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.otherNumberCommentary",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7907aba0001ac69fe",
                        "name": "text",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca6a7857aaa0001ac68db",
                        "name": "text-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 9,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2ad",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "compliantRegister",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.compliantRegister",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 10,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2b1",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "recolementSources",
                        "mandatorySystem": false,
                        "type": {
                            "type": "List",
                            "entityFieldType": {
                                "type": "RecolementSource",
                                "referenceField": false
                            },
                            "listClass": "org.skinsoft.backend.schemas.recolement.complex.RecolementSource",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [
                            {
                                "entityFieldId": "5d4c49010de7d241b997e2ae",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementCheckingSchema",
                                "name": "typeOfSource",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementCheckingSchema.recolementSources.typeOfSource",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            {
                                "entityFieldId": "5d4c49010de7d241b997e2af",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementCheckingSchema",
                                "name": "name",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementCheckingSchema.recolementSources.name",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            {
                                "entityFieldId": "5d4c49010de7d241b997e2b0",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementCheckingSchema",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementCheckingSchema.recolementSources.precision",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            }
                        ],
                        "path": "recolementCheckingSchema.recolementSources",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": false
                    },
                    "fieldFormat": {
                        "id": null,
                        "name": null,
                        "defaultFormat": null
                    },
                    "inputComponent": {
                        "id": null,
                        "name": null,
                        "defaultComponent": null
                    },
                    "formatter": null,
                    "entityFields": [
                        {
                            "entityField": {
                                "entityFieldId": "5d4c49010de7d241b997e2af",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementCheckingSchema",
                                "name": "name",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementCheckingSchema.recolementSources.name",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            "fieldFormat": {
                                "id": "595ca6a7907aba0001ac69fe",
                                "name": "text",
                                "defaultFormat": true
                            },
                            "inputComponent": {
                                "id": "595ca6a7857aaa0001ac68db",
                                "name": "text-component",
                                "defaultComponent": true
                            },
                            "formatter": null,
                            "entityFields": null,
                            "mandatoryUser": false,
                            "order": 0,
                            "tableDisplay": null,
                            "columnDisplay": null,
                            "paginated": null
                        },
                        {
                            "entityField": {
                                "entityFieldId": "5d4c49010de7d241b997e2b0",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementCheckingSchema",
                                "name": "precision",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementCheckingSchema.recolementSources.precision",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            "fieldFormat": {
                                "id": "595ca6a7907aba0001ac69fe",
                                "name": "text",
                                "defaultFormat": true
                            },
                            "inputComponent": {
                                "id": "595ca6a7857aaa0001ac68db",
                                "name": "text-component",
                                "defaultComponent": true
                            },
                            "formatter": null,
                            "entityFields": null,
                            "mandatoryUser": false,
                            "order": 1,
                            "tableDisplay": null,
                            "columnDisplay": null,
                            "paginated": null
                        },
                        {
                            "entityField": {
                                "entityFieldId": "5d4c49010de7d241b997e2ae",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementCheckingSchema",
                                "name": "typeOfSource",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementCheckingSchema.recolementSources.typeOfSource",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            "fieldFormat": {
                                "id": "595ca6a7907aba0001ac69fe",
                                "name": "text",
                                "defaultFormat": true
                            },
                            "inputComponent": {
                                "id": "595ca6a7857aaa0001ac68db",
                                "name": "text-component",
                                "defaultComponent": true
                            },
                            "formatter": null,
                            "entityFields": null,
                            "mandatoryUser": false,
                            "order": 2,
                            "tableDisplay": null,
                            "columnDisplay": null,
                            "paginated": null
                        }
                    ],
                    "mandatoryUser": false,
                    "order": 11,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2b2",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "commentaryCompliant",
                        "mandatorySystem": false,
                        "type": {
                            "type": "TranslatedString",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.commentaryCompliant",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7907aba0001ac69fe",
                        "name": "text",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca6a7857aaa0001ac68db",
                        "name": "text-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 12,
                    "tableDisplay": null,
                    "columnDisplay": null,
                    "paginated": null
                }
            ]
        },
        {
            "label": {
                "translatedString": {
                    "fr": "État",
                    "fr-ca": "État",
                    "en": "State",
                    "nl": "Staat",
                    "es": "Estado",
                    "it": "Stato",
                    "no": "Status",
                    "de": "Staat",
                },
                "translatedId": null
            },
            "maskFields": [
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e285",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementPropertyStatusSchema",
                        "name": "integrity",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementPropertyStatusSchema.integrity",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 0,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e286",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementPropertyStatusSchema",
                        "name": "deformationInstability",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementPropertyStatusSchema.deformationInstability",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 1,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e287",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementPropertyStatusSchema",
                        "name": "tracesHumidity",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementPropertyStatusSchema.tracesHumidity",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 2,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e288",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementPropertyStatusSchema",
                        "name": "tracesInfestation",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementPropertyStatusSchema.tracesInfestation",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 3,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e289",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementPropertyStatusSchema",
                        "name": "highDust",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementPropertyStatusSchema.highDust",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 4,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e2b5",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementCheckingSchema",
                        "name": "generalStatus",
                        "mandatorySystem": false,
                        "type": {
                            "type": "TranslatedString",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementCheckingSchema.generalStatus",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7907aba0001ac69fe",
                        "name": "text",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca6a7857aaa0001ac68db",
                        "name": "text-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 5,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e28c",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementPropertyStatusSchema",
                        "name": "commentOnSpecificPoints",
                        "mandatorySystem": false,
                        "type": {
                            "type": "List",
                            "entityFieldType": {
                                "type": "CommentOnSpecificPoint",
                                "referenceField": false
                            },
                            "listClass": "org.skinsoft.backend.schemas.recolement.complex.CommentOnSpecificPoint",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [
                            {
                                "entityFieldId": "5d4c49010de7d241b997e28a",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementPropertyStatusSchema",
                                "name": "commentary",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementPropertyStatusSchema.commentOnSpecificPoints.commentary",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            {
                                "entityFieldId": "5d4c49010de7d241b997e28b",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementPropertyStatusSchema",
                                "name": "typeOfCommentary",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementPropertyStatusSchema.commentOnSpecificPoints.typeOfCommentary",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            }
                        ],
                        "path": "recolementPropertyStatusSchema.commentOnSpecificPoints",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": false
                    },
                    "fieldFormat": {
                        "id": null,
                        "name": null,
                        "defaultFormat": null
                    },
                    "inputComponent": {
                        "id": null,
                        "name": null,
                        "defaultComponent": null
                    },
                    "formatter": null,
                    "entityFields": [
                        {
                            "entityField": {
                                "entityFieldId": "5d4c49010de7d241b997e28a",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementPropertyStatusSchema",
                                "name": "commentary",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementPropertyStatusSchema.commentOnSpecificPoints.commentary",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            "fieldFormat": {
                                "id": "595ca6a7907aba0001ac69fe",
                                "name": "text",
                                "defaultFormat": true
                            },
                            "inputComponent": {
                                "id": "595ca6a7857aaa0001ac68db",
                                "name": "text-component",
                                "defaultComponent": true
                            },
                            "formatter": null,
                            "entityFields": null,
                            "mandatoryUser": false,
                            "order": 0,
                            "tableDisplay": null,
                            "columnDisplay": true,
                            "paginated": null
                        },
                        {
                            "entityField": {
                                "entityFieldId": "5d4c49010de7d241b997e28b",
                                "entity": "recolement",
                                "abstractEntity": null,
                                "schema": "recolementPropertyStatusSchema",
                                "name": "typeOfCommentary",
                                "mandatorySystem": false,
                                "type": {
                                    "type": "TranslatedString",
                                    "referenceField": false
                                },
                                "isReadOnly": false,
                                "isComputed": false,
                                "entityFields": [],
                                "path": "recolementPropertyStatusSchema.commentOnSpecificPoints.typeOfCommentary",
                                "tableDisplay": null,
                                "columnDisplay": null,
                                "isChildren": true,
                                "dependOnFieldParameter": null,
                                "needId": false,
                                "readOnlyValues": null,
                                "usableForFacets": true
                            },
                            "fieldFormat": {
                                "id": "595ca6a7907aba0001ac69fe",
                                "name": "text",
                                "defaultFormat": true
                            },
                            "inputComponent": {
                                "id": "595ca6a7857aaa0001ac68db",
                                "name": "text-component",
                                "defaultComponent": true
                            },
                            "formatter": null,
                            "entityFields": null,
                            "mandatoryUser": false,
                            "order": 1,
                            "tableDisplay": null,
                            "columnDisplay": true,
                            "paginated": null
                        }
                    ],
                    "mandatoryUser": false,
                    "order": 6,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5e18304893f9c726bf07b5fd",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "existDocPhotography",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.existDocPhotography",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 7,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5e18304893f9c726bf07b5fe",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "photographyInRecolement",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.photographyInRecolement",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 8,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5e18304893f9c726bf07b5ff",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "marksPhotography",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.marksPhotography",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 9,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5e18304893f9c726bf07b600",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "identifierNumberPhotography",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.identifierNumberPhotography",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 10,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                }
            ]
        },
        {
            "label": {
                "translatedString": {
                    "fr": "Suites à donner",
                    "fr-ca": "Suites à donner",
                    "en": "Action to be taken",
                    "nl": "Opvolging",
                    "es": "Seguimiento",
                    "it": "Seguito",
                    "no": "Oppfølging",
                    "de": "Folgemaßnahmen"
                },
                "translatedId": null
            },
            "maskFields": [
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e28d",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "inventoried",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.inventoried",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 0,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e28f",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "marked",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.marked",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 1,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e291",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "photographed",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.photographed",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 2,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e293",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "processed",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.processed",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 3,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e295",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "processingDetail",
                        "mandatorySystem": false,
                        "type": {
                            "type": "TranslatedString",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.processingDetail",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7907aba0001ac69fe",
                        "name": "text",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "595ca6a7857aaa0001ac68db",
                        "name": "text-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 4,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                },
                {
                    "entityField": {
                        "entityFieldId": "5d4c49010de7d241b997e296",
                        "entity": "recolement",
                        "abstractEntity": null,
                        "schema": "recolementFollowUpActionSchema",
                        "name": "located",
                        "mandatorySystem": false,
                        "type": {
                            "type": "Boolean",
                            "referenceField": false
                        },
                        "isReadOnly": false,
                        "isComputed": false,
                        "entityFields": [],
                        "path": "recolementFollowUpActionSchema.located",
                        "tableDisplay": null,
                        "columnDisplay": null,
                        "isChildren": false,
                        "dependOnFieldParameter": null,
                        "needId": false,
                        "readOnlyValues": null,
                        "usableForFacets": true
                    },
                    "fieldFormat": {
                        "id": "595ca6a7957aba0001ac69e4",
                        "name": "yes-no",
                        "defaultFormat": true
                    },
                    "inputComponent": {
                        "id": "5959a2a7857aaa0001ac29de",
                        "name": "radio-yes-no-component",
                        "defaultComponent": true
                    },
                    "formatter": null,
                    "entityFields": null,
                    "mandatoryUser": false,
                    "order": 5,
                    "tableDisplay": null,
                    "columnDisplay": true,
                    "paginated": null
                }
            ]
        }
    ],
    "level": "adminLevel",
    "userId": "595ca6a7857aba0001a00001",
    "entityTargetId": "736bb6b8857abf0001ac9888",
    "entityTarget": "recolement",
    "isInputMask": true,
    "categoriesDisplay": true,
    "workspaceCreation": "5d6917c3fb6ee95ed082f268",
    "workspaceSharing": [],
    "isPatternMask": false,
    "pattern": null,
    "_links": {
        "self": {
            "href": "http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650"
        },
        "record-masks": {
            "href": "http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650"
        },
        "mask-fields": {
            "href": "http://127.0.0.1:8081/record-masks/6070579b0a6d211f1520a650/mask-fields"
        }
    },
    "id": "6070579b0a6d211f1520a650"
}

